export enum FacetFilterTypes {
  PRODUCT = 'product',
  DELIVERY_OPTION = 'delivery_option',
  VERSION = 'version_hierarchy',
  CONTENT_TYPE = 'source',
  LANGUAGE = 'language',
}
